import { useState, useEffect, axios, Button, Input, Card, CardContent, CardHeader, CardTitle, Label, Textarea, Badge, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Loader2, Plus, Trash2, API, useAuth, toast } from "@/pages/shared";

export default function TemplatesPage() {
  const { token } = useAuth();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [contentType, setContentType] = useState("blog");
  const [tone, setTone] = useState("professional");
  const [length, setLength] = useState("medium");
  const [promptTemplate, setPromptTemplate] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => { fetchTemplates(); }, [token]);

  const fetchTemplates = async () => {
    try { const res = await axios.get(`${API}/templates`, { headers: { Authorization: `Bearer ${token}` } }); setTemplates(res.data); } catch (e) { console.error(e); }
    setLoading(false);
  };

  const createTemplate = async () => {
    if (!name.trim() || !promptTemplate.trim()) { toast.error("Please fill in all fields"); return; }
    setCreating(true);
    try {
      await axios.post(`${API}/templates`, { name, content_type: contentType, tone, length, prompt_template: promptTemplate }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Template created!"); setName(""); setPromptTemplate(""); fetchTemplates();
    } catch (e) { toast.error("Failed to create template"); }
    setCreating(false);
  };

  const deleteTemplate = async (id) => {
    try { await axios.delete(`${API}/templates/${id}`, { headers: { Authorization: `Bearer ${token}` } }); toast.success("Template deleted"); fetchTemplates(); } catch (e) { toast.error("Failed to delete"); }
  };

  return (
    <div className="space-y-8">
      <div><h1 className="text-3xl font-bold mb-2">Content Templates</h1><p className="text-muted-foreground">Save and reuse your best content prompts</p></div>
      <Card className="glass">
        <CardHeader><CardTitle>Create New Template</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div><Label>Template Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="My Blog Template" className="mt-1 bg-white/5 border-white/10" /></div>
            <div><Label>Content Type</Label><Select value={contentType} onValueChange={setContentType}><SelectTrigger className="mt-1 bg-white/5 border-white/10"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="blog">Blog Post</SelectItem><SelectItem value="social">Social Media</SelectItem><SelectItem value="ad_copy">Ad Copy</SelectItem><SelectItem value="twitter">Twitter Thread</SelectItem></SelectContent></Select></div>
            <div><Label>Tone</Label><Select value={tone} onValueChange={setTone}><SelectTrigger className="mt-1 bg-white/5 border-white/10"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="professional">Professional</SelectItem><SelectItem value="casual">Casual</SelectItem><SelectItem value="humorous">Humorous</SelectItem></SelectContent></Select></div>
            <div><Label>Length</Label><Select value={length} onValueChange={setLength}><SelectTrigger className="mt-1 bg-white/5 border-white/10"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="short">Short</SelectItem><SelectItem value="medium">Medium</SelectItem><SelectItem value="long">Long</SelectItem></SelectContent></Select></div>
          </div>
          <div><Label>Prompt Template (placeholders: {"{topic}"}, {"{tone}"}, {"{length}"})</Label><Textarea value={promptTemplate} onChange={(e) => setPromptTemplate(e.target.value)} placeholder="Write a {length} blog post about {topic} in a {tone} tone..." className="mt-1 bg-white/5 border-white/10 h-24" /></div>
          <Button onClick={createTemplate} disabled={creating} className="btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full">{creating ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Plus className="w-4 h-4 mr-2" />}Create Template</Button>
        </CardContent>
      </Card>
      <Card className="glass">
        <CardHeader><CardTitle>Your Templates</CardTitle></CardHeader>
        <CardContent>
          {loading ? <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin" /></div> : templates.length === 0 ? <p className="text-muted-foreground text-center py-8">No templates yet</p> : (
            <div className="space-y-4">
              {templates.map((t) => (
                <div key={t.id} className="flex items-center justify-between p-4 rounded-lg bg-white/5">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1"><p className="font-medium">{t.name}</p><Badge variant="secondary">{t.content_type}</Badge><Badge variant="outline">{t.usage_count} uses</Badge></div>
                    <p className="text-sm text-muted-foreground line-clamp-1">{t.prompt_template}</p>
                  </div>
                  <Button variant="ghost" size="icon" onClick={() => deleteTemplate(t.id)}><Trash2 className="w-4 h-4 text-destructive" /></Button>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
